import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "bar", "hint"]
  static values = {
    weakLabel: String,
    mediumLabel: String,
    strongLabel: String
  }

  connect() {
    this.update()
  }

  update() {
    const score = this.score(this.inputTarget.value)
    this.barTarget.dataset.strength = score.level
    this.barTarget.style.width = `${score.percent}%`
    this.hintTarget.textContent = score.hint
    this.hintTarget.dataset.strength = score.level
  }

  score(value) {
    if (!value) return { level: "empty", percent: 0, hint: "" }

    let points = 0
    if (value.length >= 8) points++
    if (value.length >= 12) points++
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) points++
    if (/\d/.test(value)) points++
    if (/[^A-Za-z0-9]/.test(value)) points++

    if (points <= 2) return { level: "weak", percent: 33, hint: this.weakLabelValue }
    if (points <= 3) return { level: "medium", percent: 66, hint: this.mediumLabelValue }
    return { level: "strong", percent: 100, hint: this.strongLabelValue }
  }
}
